<p-dialog [(visible)]="displaySearchDialog" [modal]="true" [style]="" (onHide)="cancelSearch()">
  <ng-template pTemplate="header">
    <div class="w-full text-center font-22 font-weight-600" translate>customer_mngt.adv_search
    </div>
  </ng-template>
  <div class="">
    <form #form="ngForm" (ngSubmit)="onSearch()">
      <div class="">
        <div class="formgrid grid m-auto">
          <div class="field col">
            <div class="row form-input-row">
              <div class="col-5 text-right pr-0">
                <span translate>customer_mngt.customer_id</span>:
              </div>
              <div class="col-7 group-item">
                <input name="customerId" type="text" class="form-control w-full" pInputText
                  [(ngModel)]="customerFilter.customerNumber" maxLength="30"
                  (keypress)="allowAlphanumericSpace($event)"/>
                  @if (customerFilter.customerNumber) {
                    <i class="pi pi-times remove-button"
                    (click)="customerFilter.customerNumber = undefined;"></i>
                  }
                </div>
              </div>

              <div class="row form-input-row">
                <div class="col-5 text-right pr-0">
                  <span translate>customer_mngt.status</span>:
                </div>
                <div class="col-7 group-item">
                  <p-dropdown [options]="statuses" styleClass="inputfield w-100" class="dropdowns"
                    name="statuses" [(ngModel)]="customerFilter.status"
                    optionLabel="label" optionValue="value"
                    placeholder="Select Customer Status">

                  </p-dropdown>
                  @if (customerFilter.status) {
                    <i class="pi pi-times remove-button-dropdown"
                    (click)="customerFilter.status = undefined"></i>
                  }
                </div>
              </div>

              <div class="row form-input-row">
                <div class="col-5 text-right pr-0">
                  <span translate>customer_mngt.dob</span>:
                </div>
                <div class="col-7" #birthdate>
                  <p-calendar [(ngModel)]="customerFilter.birthDate" class="w-full custom-calendar" [showIcon]="true"
                    [showOnFocus]="false" placeholder="dd-mm-yyyy"
                    dateFormat="dd-mm-yy" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                    name="customerBirthDate" dataType="string" [showButtonBar]="true"
                    [monthNavigator]="true" [yearNavigator]="true" [yearRange]="yearRange">
                  </p-calendar>
                </div>
              </div>

              <div class="row form-input-row">
                <div class="col-5 text-right pr-0">
                  <span translate>customer_mngt.gender</span>:
                </div>
                <div class="col-7 group-item">
                  <p-dropdown [options]="genders" styleClass="inputfield w-100" class="dropdowns"
                    name="genders" [(ngModel)]="customerFilter.gender"
                    optionLabel="label" optionValue="value"
                    placeholder="Select Gender">
                  </p-dropdown>
                  @if (customerFilter.gender) {
                    <i class="pi pi-times remove-button-dropdown"
                    (click)="customerFilter.gender = undefined"></i>
                  }
                </div>
              </div>

              <div class="row form-input-row">
                <div class="col-5 text-right pr-0">
                  <span translate>customer_mngt.first-name</span>:
                </div>
                <div class="col-7 group-item">
                  <input type="text" name="firstName" pInputText class="form-control w-full"
                    [(ngModel)]="customerFilter.firstName" maxLength="50"
                    (keypress)="allowAlphanumericSpace($event)" autocomplete="off">
                    @if (customerFilter.firstName) {
                      <i class="pi pi-times remove-button"
                      (click)="customerFilter.firstName = undefined"></i>
                    }
                  </div>
                </div>

                <div class="row form-input-row">
                  <div class="col-5 text-right pr-0">
                    <span translate>customer_mngt.middle-name</span>:
                  </div>
                  <div class="col-7 group-item">
                    <input type="text" name="middleName" pInputText class="form-control w-full"
                      [(ngModel)]="customerFilter.middleName" maxLength="50"
                      (keypress)="allowAlphanumericSpace($event)" autocomplete="off">
                      @if (customerFilter.middleName) {
                        <i class="pi pi-times remove-button"
                        (click)="customerFilter.middleName = undefined"></i>
                      }
                    </div>
                  </div>
                  <div class="row form-input-row">
                    <div class="col-5 text-right pr-0">
                      <span translate>customer_mngt.last-name</span>:
                    </div>
                    <div class="col-7 group-item">
                      <input type="text" name="lastName" id="lastName" pInputText class="form-control w-full"
                        [(ngModel)]="customerFilter.lastName" maxLength="50"
                        (keypress)="allowAlphanumericSpace($event)" autocomplete="off">
                        @if (customerFilter.lastName) {
                          <i class="pi pi-times remove-button"
                          (click)="customerFilter.lastName = undefined"></i>
                        }
                      </div>
                    </div>


                  </div>

                  <div class="field col">
                    <div class="row form-input-row">
                      <div class="col-5 text-right pr-0">
                        <span translate>customer_mngt.id_card</span>:
                      </div>
                      <div class="col-7 group-item">
                        <input type="idCard" name="idCard" pInputText class="form-control w-full"
                          [(ngModel)]="customerFilter.idCard" maxLength="20"
                          (keypress)="allowAlphanumericSpace($event)" autocomplete="off">
                          @if (customerFilter.idCard) {
                            <i class="pi pi-times remove-button"
                            (click)="customerFilter.idCard = undefined"></i>
                          }
                        </div>
                      </div>
                      <div class="row form-input-row">
                        <div class="col-5 text-right pr-0">
                          <span translate>customer_mngt.ssn</span>:
                        </div>
                        <div class="col-7 group-item">
                          <input type="text" name="socialSecurityNumber" pInputText class="form-control w-full"
                            [(ngModel)]="customerFilter.socialSecurityNumber" maxLength="20"
                            (keypress)="allowAlphanumericSpace($event)" autocomplete="off">
                            @if (customerFilter.socialSecurityNumber) {
                              <i class="pi pi-times remove-button"
                              (click)="customerFilter.socialSecurityNumber = undefined"></i>
                            }
                          </div>
                        </div>
                        <div class="row form-input-row">
                          <div class="col-5 text-right pr-0">
                            <span translate>customer_mngt.phone</span>:
                          </div>
                          <div class="col-7 group-item">
                            <input type="text" name="phone" pInputText class="form-control w-full"
                              (keypress)="numberOnly($event)" autocomplete="off"
                              [(ngModel)]="customerFilter.phoneNumber" maxLength="20">
                              @if (customerFilter.phoneNumber) {
                                <i class="pi pi-times remove-button"
                                (click)="customerFilter.phoneNumber = undefined"></i>
                              }
                            </div>
                          </div>

                          <div class="row form-input-row">
                            <div class="col-5 text-right pr-0">
                              <span translate>common.address</span>:
                            </div>
                            <div class="col-7 group-item">
                              <input type="text" name="street" pInputText class="form-control w-full"
                                [(ngModel)]="customerFilter.street" maxLength="200"
                                autocomplete="off">
                                @if (customerFilter.street) {
                                  <i class="pi pi-times remove-button"
                                  (click)="customerFilter.street = undefined"></i>
                                }
                              </div>
                            </div>

                            <div class="row form-input-row">
                              <div class="col-5 text-right pr-0">
                                <span translate>customer_mngt.customer_table.document</span>:
                              </div>
                              <div class="col-7 group-item">
                                <input type="text" name="passport" id="passport" pInputText class="form-control w-full"
                                  [(ngModel)]="customerFilter.passportSerialNumber" maxLength="20"
                                  (keypress)="allowAlphanumericSpace($event)" autocomplete="off">
                                  @if (customerFilter.passportSerialNumber) {
                                    <i class="pi pi-times remove-button"
                                    (click)="customerFilter.passportSerialNumber = undefined"></i>
                                  }
                                </div>
                              </div>

                                <div class="row form-input-row">
                                  <div class="col-5 text-right pr-0">
                                    <span translate>customer_mngt.email</span>:
                                  </div>
                                  <div class="col-7 group-item">
                                    <input type="email" name="emailInput" pInputText class="form-control w-full"
                                        [(ngModel)]="customerFilter.email" #emailInput="ngModel" maxLength="150"
                                        (focusout)="isValidEmail()">
                                    @if (customerFilter.email) {
                                      <i class="pi pi-times remove-button"
                                      (click)="customerFilter.email = undefined; isValidEmail()"></i>
                                    }
                                    @if (emailMessage) {
                                      <div class="w-full text-left email-error">
                                            <small class="text-danger">
                                              {{emailMessage}}
                                            </small>
                                      </div>
                                    }
                                  </div>
                                </div>


                                <!--                        <div class="row form-input-row">-->
                                <!--                            <div class="col-5 text-right pr-0">-->
                                <!--                                <span translate>customer_mngt.taxplayer</span>:-->
                              <!--                            </div>-->
                              <!--                            <div class="col-7 group-item">-->
                              <!--                                <input type="text" name="taxplayer" pInputText class="form-control w-full"-->
                              <!--                                       [(ngModel)]="customerFilter.taxpayerId" maxLength="30"-->
                              <!--                                       (keypress)="allowAlphanumericSpace($event)">-->
                              <!--                                        <i *ngIf="customerFilter.taxpayerId" class="pi pi-times remove-button"-->
                            <!--                                        (click)="customerFilter.taxpayerId = undefined"></i>-->
                          <!--                            </div>-->
                        <!--                        </div>-->
                        <!--                        <div class="row form-input-row">-->
                        <!--                            <div class="col-5 text-right pr-0">-->
                        <!--                                <span translate>customer_mngt.commercial.name</span>:-->
                      <!--                            </div>-->
                      <!--                            <div class="col-7 group-item">-->
                      <!--                                <input type="text" name="commercialName" pInputText class="form-control w-full"-->
                      <!--                                        [(ngModel)]="customerFilter.commercialName" maxLength="50"-->
                      <!--                                        (keypress)="allowAlphanumericSpace($event)">-->
                      <!--                                        <i *ngIf="customerFilter.commercialName" class="pi pi-times remove-button"-->
                    <!--                                        (click)="customerFilter.commercialName = undefined"></i>-->
                  <!--                            </div>-->
                <!--                        </div>-->
                <!--                        <div class="row form-input-row">-->
                <!--                            <div class="col-5 text-right pr-0">-->
                <!--                                <span translate>customer_mngt.commercial.address</span>:-->
              <!--                            </div>-->
              <!--                            <div class="col-7 group-item">-->
              <!--                                <input type="text" name="address" pInputText class="form-control w-full"-->
              <!--                                        [(ngModel)]="customerFilter.commercialAddress" maxLength="200"-->
              <!--                                        (keypress)="allowAlphanumericSpace($event)">-->
              <!--                                        <i *ngIf="customerFilter.commercialAddress" class="pi pi-times remove-button"-->
            <!--                                        (click)="customerFilter.commercialAddress = undefined"></i>-->
          <!--                            </div>-->
        <!--                        </div>-->

        <!--                        <div class="row form-input-row">-->
        <!--                            <div class="col-5 text-right pr-0">-->
        <!--                                <span translate>customer_mngt.customer_table.foreign_passport</span>:-->
      <!--                            </div>-->
      <!--                            <div class="col-7 group-item">-->
      <!--                                <input type="text" name="foreignPassport" id="foreignPassport" pInputText class="form-control w-full"-->
      <!--                                       [(ngModel)]="customerFilter.foreignPassport" maxLength="20"-->
      <!--                                       (keypress)="allowAlphanumericSpace($event)">-->
      <!--                                <i *ngIf="customerFilter.foreignPassport" class="pi pi-times remove-button"-->
    <!--                                   (click)="customerFilter.foreignPassport = undefined"></i>-->
  <!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="row form-input-row">-->
<!--                            <div class="col-5 text-right pr-0">-->
<!--                                <span translate>customer_mngt.customer_table.other_document</span>:-->
<!--                            </div>-->
<!--                            <div class="col-7 group-item">-->
<!--                                <input type="text" name="otherDocument" id="otherDocument" pInputText class="form-control w-full"-->
<!--                                       [(ngModel)]="customerFilter.otherDocument" maxLength="20"-->
<!--                                       (keypress)="allowAlphanumericSpace($event)">-->
<!--                                <i *ngIf="customerFilter.otherDocument" class="pi pi-times remove-button"-->
<!--                                   (click)="customerFilter.otherDocument = undefined"></i>-->
<!--                            </div>-->
<!--                        </div>-->

</div>
</div>

<div class="pt-20">
  <div class="d-flex justify-content-center">
    <app-button id="btn-search" buttonClass="btn-primary" buttonType="submit"
      [isDisabled]="emailMessage">
      <span translate>buttons.search</span>
    </app-button>
    <app-button id="cancel-search" buttonClass="btn-secondary"
      (clickEvent)="cancelSearch()">
      <span translate>buttons.cancel</span>
    </app-button>

  </div>
</div>
</div>
</form>
</div>
</p-dialog>
